import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { styled, Stack, Typography, Box } from '@mui/material';
import { NavLink } from 'react-router';

export const StyledHeaderAndLabelWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

export const StyledHeader = styled(Typography)({
  fontSize: '18px',
  fontWeight: 500,
});

export const StyledUpgradeBannerWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'flex-start',
}));

export const StyledUpgradeBannerContainer = styled(Stack)({
  background: '#FFF7ED',
  border: '1px solid #FED7AA',
  padding: '24px',
  borderRadius: '8px',
});

export const StyledUpgradeBannerHeader = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  display: 'flex',
  msFlexDirection: 'column',
}));

export const StyledTitle = styled(Typography)({
  color: '#111827',
  fontFamily: '"Inter", sans-serif',
  fontWeight: 500,
});

export const StyledDescription = styled(Typography)({
  color: '#4B5563',
  fontWeight: '16px',
});

export const StyledUpgradeBannerButton = styled(NavLink)({
  background: '#6D77C8',
  color: '#FFFFFF',
  fontSize: '14px',
  borderRadius: '50px',
  padding: '8px 16px',
  width: 'fit-content',
  marginTop: '12px',
  '&:hover': {
    opacity: 1,
    backgroundColor: '#575FA0',
  },
});

export const StyledInfoIcon = styled(InfoOutlineIcon)({
  color: '#F97316FF',
});
